import React from 'react';
import { Link } from 'react-router-dom';
import StoreLayout from './StoreLayout';
import ProductCard from './ProductCard';
import { useProductsByIds } from './catalogApi';
import { useWishlist } from './savedLists';
import { useDocumentTitle } from './retailUtils';

export default function StoreWishlistPage() {
  const ids = useWishlist();
  const { products: saved, loading } = useProductsByIds(ids);
  useDocumentTitle('Wishlist');

  return (
    <StoreLayout>
      <h1 className="rt-page-title">Wishlist {saved.length > 0 && <span style={{ fontWeight: 500, color: '#6B7280', fontSize: 18 }}>({saved.length})</span>}</h1>
      {loading && ids.length > 0 ? (
        <div className="rt-grid rt-grid--roomy" aria-hidden="true">{ids.slice(0, 4).map(id => <div key={id} className="rt-skel" style={{ aspectRatio: '3 / 4' }} />)}</div>
      ) : saved.length === 0 ? (
        <div className="rt-empty">
          <h2>Save what you love</h2>
          <p>Tap the heart on any product to keep it here — no account needed.</p>
          <Link to="/catalog" className="rt-btn" style={{ marginTop: 12 }}>Start shopping</Link>
        </div>
      ) : (
        <div className="rt-grid rt-grid--roomy">{saved.map(p => <ProductCard key={p.id} product={p} />)}</div>
      )}
    </StoreLayout>
  );
}
